import { ReactComponent as HandleArrowUpIcon } from '@assets/images/app/handle-arrow-up.svg';
import React from 'react';

interface ProductCalendarCartFooterProps {
  count: number;
  totalFee: number;
  onExpand: () => void;
  onPurchase: () => void;
}

export const ProductCalendarCartFooter: React.FC<ProductCalendarCartFooterProps> = ({
  count,
  totalFee,
  onExpand,
  onPurchase,
}) => {
  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#FFFFFF',
        borderTop: '1px solid #F5F7FB',
        padding: '0 16px',
        paddingBottom: 12,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexShrink: 0,
        boxSizing: 'border-box',
      }}>
      <button
        type="button"
        className="link-button"
        onClick={onExpand}
        aria-label="담은 옵션 보기"
        style={{
          width: '100%',
          height: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <HandleArrowUpIcon width={44} height={10} />
      </button>
      <button
        type="button"
        className="link-button"
        onClick={onPurchase}
        style={{
          width: '100%',
          height: 56,
          borderRadius: 8,
          background: 'var(--Primary-95, #FF3D8F)',
          color: '#FFFFFF',
          fontSize: 16,
          fontWeight: 700,
          lineHeight: '22px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6,
        }}>
        <span
          style={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            background: '#FFFFFF',
            color: 'var(--Primary-95, #FF3D8F)',
            fontSize: 14,
            fontWeight: 800,
            lineHeight: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          {count}
        </span>
        <span>{totalFee.toLocaleString()}원 구매하기</span>
      </button>
    </div>
  );
};
